import { memo, useEffect, useRef, useState } from "react";
import styles from "./ColoredChanges.module.scss";
import cn from "classnames";
import { IColoredChanges } from "./ColoredChanges.props";

function ColoredChanges({
  className,
  children,
  style,

  onClick,
  ...props
}: IColoredChanges) {
  const [oldValue, setOldValue] = useState<string | undefined>(children?.toString());
  const [changed, setChanged] = useState<boolean>(false);

  useEffect(() => {
    const c = children?.toString();
    setOldValue(c);
    if (oldValue !== c) {
      setChanged(true);
      const time = setTimeout(() => setChanged(false), 500);
      return () => clearTimeout(time);
    }
  }, [children]);

  return (
    <div
      className={cn(styles.wrapper, className)}
      style={style}
      onClick={onClick}
    >
      <div
        className={cn(styles.changeable, {
          [styles.change]: changed,
          [styles.textRight]: !!props.textRight,
        })}
      >
        {children}
      </div>
    </div>
  );
}

export default memo(ColoredChanges);
